import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { errText } from "../lib/errors";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { toast.error("Şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      setDone(true);
    } catch (err) {
      toast.error(errText(err) || "Sıfırlanamadı");
    } finally { setBusy(false); }
  };

  const inputCls = "w-full h-12 px-4 rounded-xl border border-stone-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-forest/30 focus:border-forest";

  return (
    <div data-testid="reset-password-page" className="max-w-md mx-auto px-4 py-14">
      <div className="bg-white rounded-3xl border border-stone-200/80 p-8 shadow-sm">
        <h1 className="font-serif text-3xl text-forest text-center">Yeni Şifre Belirle</h1>
        {done ? (
          <div className="mt-6 text-center">
            <div data-testid="reset-success" className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-xl p-4 flex items-center justify-center gap-2">
              <CheckCircle2 className="w-4 h-4" /> Şifreniz güncellendi — yeni şifrenizle giriş yapabilirsiniz.
            </div>
            <Link to="/giris" data-testid="reset-goto-login" className="inline-block mt-5 bg-forest hover:bg-forest-dark text-white text-sm font-bold px-8 py-3 rounded-xl transition-colors">Giriş Yap</Link>
          </div>
        ) : !token ? (
          <div className="mt-6 text-center">
            <p data-testid="reset-no-token" className="text-sm text-terra bg-red-50 border border-red-200 rounded-xl p-4">Geçersiz bağlantı — lütfen e-postanızdaki bağlantıyı kullanın veya yeni bağlantı isteyin.</p>
            <Link to="/sifremi-unuttum" data-testid="reset-goto-forgot" className="inline-block mt-5 text-sm font-semibold text-forest hover:underline">Yeni bağlantı iste</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <input data-testid="reset-password" type="password" required minLength={6} className={inputCls} placeholder="Yeni şifre (en az 6 karakter)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <input data-testid="reset-confirm" type="password" required minLength={6} className={inputCls} placeholder="Yeni şifre (tekrar)" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
            <button data-testid="reset-submit" disabled={busy} className="w-full flex items-center justify-center gap-2 bg-forest hover:bg-forest-dark disabled:bg-stone-400 text-white font-semibold py-3.5 rounded-xl transition-colors">
              <KeyRound className="w-4 h-4" /> {busy ? "Kaydediliyor..." : "Şifremi Güncelle"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
